import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import List from '@zenbusiness/zui/List';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import { styled, alpha } from '@zenbusiness/zui/styles';

export const ListCard = styled(List)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  gap: 16,

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(2, 1fr)'
  },

  [theme.breakpoints.up('lg')]: {
    gap: 24,
    gridTemplateColumns: 'repeat(3, 1fr)'
  }
}));

export const ProductCard = styled(Card)(({ theme }) => ({
  padding: '1.5rem',
  height: '100%',
  boxShadow:  theme.shadows[1]
}));

export const CardImageContainer = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.shape.rounded.full,
  backgroundColor: alpha(theme.palette.background.blue.light, 0.2),

  width: '4.375rem',
  height: '4.375rem',

  [theme.breakpoints.up('lg')]: {
    width: '4.875rem',
    height: '4.875rem'
  }
}));

export const CardImage = styled(SharedAsset)(({ theme }) => ({
  width: '3.125rem',
  height: '3.125rem',
  objectFit: 'contain',

  [theme.breakpoints.up('lg')]: {
    width: '3.5rem',
    height: '3.5rem'
  }
}));

export const SpinnerContainer = styled(Box)(({ theme }) => ({
  inset: 0,
  width: '100%',
  minHeight: '100vh',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',

  '& .ZuiLoadingSpinner-root': {
    marginTop: theme.spacing(12)
  }
}));
